import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.staff.call');
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { KioskContext, MeetingContext, MeetingLocation } from "src/libs/portal/kiosk/context";

type StaffOrgId = 'ceo' | 'operations' | 'ai-solution' | 'ai-research';

interface StaffMember {
    id: string;
    name: string;
    role: string;
}

interface StaffTeam {
    name: string;
    members: StaffMember[];
}

interface StaffOrg {
    id: StaffOrgId;
    name: string;
    subtitle: string;
    teams: StaffTeam[];
}

interface StaffCallTarget {
    id: string;
    name: string;
    role: string;
    orgId: StaffOrgId;
    orgName: string;
    teamName: string;
}

@Component({
    selector: 'wiz-portal-staff-call',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.staff.call/view.scss */
:host {
  display: block;
}`],
})
export class PortalStaffCallComponent implements OnInit, OnDestroy {
    public selectedOrgId: StaffOrgId | null = null;
    public staffModalVisible: boolean = false;
    public selectedStaff: StaffCallTarget[] = [];
    public calledStaff: StaffCallTarget[] = [];
    public callSubmitting: boolean = false;
    public callSuccessVisible: boolean = false;
    public lastCallId: string = '';
    public lastCallLocationLabel: string = '';
    public timeText: string = '--:--';
    public dateText: string = '';
    public meetingLocation: MeetingLocation | null = null;
    public meetingContext: MeetingContext = { meetingId: '', reservationId: '', meetingTitle: '' };
    public showLocationSelector: boolean = false;

    private clockTimer: any = null;
    private destroyed: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private ref: ChangeDetectorRef) { }

    public staffOrgs: StaffOrg[] = [
        {
            id: 'ceo',
            name: '대표',
            subtitle: '경영 의사결정',
            teams: [
                {
                    name: '대표',
                    members: [
                        { id: 'ceo-chaeyounghoon', role: '대표', name: '채영훈' }
                    ]
                }
            ]
        },
        {
            id: 'operations',
            name: '운영본부',
            subtitle: '운영 총괄',
            teams: [
                {
                    name: '운영본부',
                    members: [
                        { id: 'operations-leedaegyeom', role: '본부장', name: '이대겸' }
                    ]
                }
            ]
        },
        {
            id: 'ai-solution',
            name: 'AI솔루션센터',
            subtitle: 'WA팀, 지능화 연구실, 전산실',
            teams: [
                {
                    name: '센터장',
                    members: [
                        { id: 'solution-kwontaewook', role: '센터장', name: '권태욱' }
                    ]
                },
                {
                    name: 'WA팀',
                    members: [
                        { id: 'solution-wa-jeongchorong', role: '팀장', name: '정초롱' },
                        { id: 'solution-wa-moonseonmin', role: '담당', name: '문선민' },
                        { id: 'solution-wa-hongjiyoon', role: '담당', name: '홍지윤' }
                    ]
                },
                {
                    name: '지능화 연구실',
                    members: [
                        { id: 'solution-lab-kimyeeun', role: '실장', name: '김예은' }
                    ]
                },
                {
                    name: '전산실',
                    members: [
                        { id: 'solution-it-sojeongyoon', role: '실장', name: '소정윤' }
                    ]
                }
            ]
        },
        {
            id: 'ai-research',
            name: 'AI연구센터',
            subtitle: '응용개발팀, 연구전략팀, 데이터큐레이션팀',
            teams: [
                {
                    name: '센터장',
                    members: [
                        { id: 'research-choegang', role: '센터장', name: '최강' }
                    ]
                },
                {
                    name: '응용개발팀',
                    members: [
                        { id: 'research-dev-kimyoungjoo', role: '팀장', name: '김영주' },
                        { id: 'research-dev-kimbomi', role: '담당', name: '김보미' },
                        { id: 'research-dev-imheejin', role: '담당', name: '임희진' }
                    ]
                },
                {
                    name: '연구전략팀',
                    members: [
                        { id: 'research-strategy-leejaemoon', role: '팀장', name: '이재문' }
                    ]
                },
                {
                    name: '데이터큐레이션팀',
                    members: [
                        { id: 'research-data-kimjiwon', role: '담당', name: '김지원' }
                    ]
                }
            ]
        }
    ];

    public async ngOnInit() {
        await this.service.init(null as any);
        this.meetingLocation = KioskContext.loadMeetingLocation();
        this.meetingContext = KioskContext.loadMeetingContext();
        this.showLocationSelector = !this.meetingLocation;
        this.updateClock();
        this.clockTimer = setInterval(() => this.updateClock(), 1000 * 30);
    }

    public ngOnDestroy() {
        this.destroyed = true;
        if (this.clockTimer) clearInterval(this.clockTimer);
    }

    public get selectedOrg() {
        return this.staffOrgs.find((org) => org.id === this.selectedOrgId) || null;
    }

    public get selectedOrgTeams() {
        const org = this.selectedOrg;
        return org ? org.teams : [];
    }

    public get selectedOrgName() {
        const org = this.selectedOrg;
        return org ? org.name : '';
    }

    public get selectedOrgSubtitle() {
        const org = this.selectedOrg;
        return org ? org.subtitle : '';
    }

    public onLocationChange(location: MeetingLocation) {
        this.meetingLocation = location;
        this.showLocationSelector = false;
        this.render();
    }

    public closeLocationSelector() {
        if (!this.meetingLocation) return;

        this.showLocationSelector = false;
        this.render();
    }

    public changeMeetingLocation() {
        this.showLocationSelector = true;
        this.render();
    }

    public goHome() {
        this.service.href('/kiosk/main');
    }

    public goBack() {
        this.selectedStaff = [];
        this.calledStaff = [];
        this.selectedOrgId = null;
        this.staffModalVisible = false;
        this.callSuccessVisible = false;
        this.service.href('/kiosk/main');
    }

    public selectOrg(org: StaffOrg) {
        if (!org) return;

        this.selectedOrgId = org.id;
        this.staffModalVisible = true;
        this.callSuccessVisible = false;
        this.render();
    }

    public closeStaffModal() {
        this.staffModalVisible = false;
        this.render();
    }

    public selectedOrgCount(org: StaffOrg) {
        if (!org) return 0;

        return this.selectedStaff.filter((target) => target.orgId === org.id).length;
    }

    public isSelected(memberId: string) {
        return this.selectedStaff.some((target) => target.id === memberId);
    }

    public toggleMember(team: StaffTeam, member: StaffMember) {
        const org = this.selectedOrg;
        if (!org || !team || !member) return;

        if (this.isSelected(member.id)) {
            this.selectedStaff = this.selectedStaff.filter((target) => target.id !== member.id);
        } else {
            this.selectedStaff.push({
                id: member.id,
                name: member.name,
                role: member.role,
                orgId: org.id,
                orgName: org.name,
                teamName: team.name
            });
        }

        this.callSuccessVisible = false;
        this.render();
    }

    public removeSelectedTarget(target: StaffCallTarget) {
        if (!target) return;

        this.selectedStaff = this.selectedStaff.filter((item) => item.id !== target.id);
        this.render();
    }

    public clearSelectedStaff() {
        this.selectedStaff = [];
        this.render();
    }

    public formatTarget(target: StaffCallTarget) {
        return `${target.orgName} / ${target.teamName} / ${target.role}`;
    }

    public async submitCall() {
        if (this.selectedStaff.length === 0 || this.callSubmitting) return;

        const callLocation = this.resolveCallLocation();
        if (!callLocation) {
            this.showLocationSelector = true;
            this.render();
            await this.showError('호실과 장소를 먼저 선택해주세요.', '직원 호출에 실패했습니다.');
            return;
        }

        this.meetingLocation = callLocation;
        const employees = this.selectedStaff.map((target) => ({ ...target }));
        const payload = {
            room: callLocation.room,
            room_name: callLocation.roomName,
            place: callLocation.place,
            location_label: callLocation.label,
            meeting_id: this.meetingContext.meetingId,
            reservation_id: this.meetingContext.reservationId,
            meeting_title: this.meetingContext.meetingTitle,
            employees
        };

        this.staffModalVisible = false;
        this.callSubmitting = true;
        this.callSuccessVisible = false;
        this.render();

        try {
            const response: any = await wiz.call('save', {
                data: JSON.stringify(payload)
            });

            if (response?.code !== 200) {
                throw new Error(this.getErrorMessage(response?.data, '직원 호출 저장에 실패했습니다.'));
            }

            this.lastCallId = response?.data?.id || '';
            this.lastCallLocationLabel = this.callLocationLabel(response?.data, callLocation);
            this.calledStaff = employees;
            this.selectedStaff = [];
            this.callSubmitting = false;
            this.callSuccessVisible = true;
            this.render();

            await this.service.sleep(1800);
            if (!this.destroyed) this.service.href('/kiosk/main');
        } catch (error) {
            this.callSubmitting = false;
            this.callSuccessVisible = false;
            this.render();
            await this.showError(this.getErrorMessage(error, '직원 호출 저장에 실패했습니다.'), '직원 호출에 실패했습니다.');
        } finally {
            this.callSubmitting = false;
            this.render();
        }
    }

    private updateClock() {
        const clock = KioskContext.clockText();
        this.timeText = clock.timeText;
        this.dateText = clock.dateText;
        this.render();
    }

    private resolveCallLocation() {
        const storedLocation = KioskContext.loadMeetingLocation();
        return storedLocation || this.meetingLocation;
    }

    private callLocationLabel(call: any, fallback: MeetingLocation) {
        if (call?.location_label) return `${call.location_label}`;

        const roomName = call?.room_name || fallback.roomName;
        const place = call?.place || fallback.place;
        return `${roomName} ${place}`.trim();
    }

    private getErrorMessage(error: any, fallback: string = '요청에 실패했습니다.') {
        if (!error) return fallback;
        if (typeof error === 'string') return error;
        if (error.message) return error.message;

        return fallback;
    }

    private async showError(message: string, fallback: string = '요청에 실패했습니다.') {
        const errorMessage = message || fallback;
        if (this.service?.modal?.error) {
            await this.service.modal.error(errorMessage);
            return;
        }

        window.alert(errorMessage);
    }

    private render() {
        if (this.destroyed) return;

        setTimeout(() => {
            if (this.destroyed) return;

            this.ref.detectChanges();
            if (this.service && this.service.inited) this.service.render();
        }, 0);
    }
}

export default PortalStaffCallComponent;